import * as React from "react";
import { memo } from "react";

const SvgSmartTv = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.955 0a.61.61 0 0 0-.606.606l.005-.047s-.054.306-.125.735H.26a.26.26 0 0 0-.261.26v11.088c0 .144.117.26.26.26h4.18l-.668.89a.261.261 0 0 0 .05.368.26.26 0 0 0 .366-.055l.901-1.202h7.973l.9 1.202a.26.26 0 0 0 .417-.313l-.667-.89h4.178a.26.26 0 0 0 .26-.26V11.47h.625a.61.61 0 0 0 .606-.605l-.005.046S20 7.525 20 5.74c0-1.785-.623-5.181-.623-5.181l.002.015C19.343.284 19.108 0 18.775 0h-3.82Zm0 .52h3.82c.05 0 .076.027.087.117l.002.015s.616 3.428.615 5.088c0 1.66-.615 5.077-.615 5.077a.253.253 0 0 0-.004.047c0 .051-.033.084-.084.084h-3.821c-.05 0-.076-.026-.087-.116a.154.154 0 0 0-.002-.015S14.25 7.4 14.25 5.74c0-1.66.616-5.088.616-5.088a.248.248 0 0 0 .004-.046c0-.052.033-.085.085-.085Zm.948.64a.567.567 0 1 0 0 1.134.567.567 0 0 0 0-1.134Zm1.924 0a.567.567 0 1 0 0 1.134.567.567 0 0 0 0-1.134ZM.521 1.815h13.625c-.182 1.152-.416 2.815-.416 3.925 0 1.778.617 5.129.621 5.155.036.29.272.574.604.574h2.675v.913H.52V1.815Zm15.382 1.223a.567.567 0 1 0-.001 1.135.567.567 0 0 0 0-1.135Zm1.924 0a.567.567 0 1 0 0 1.135.567.567 0 0 0 0-1.135Zm-1.266 2.44a.132.132 0 0 0-.132.133v.727h-.727a.132.132 0 0 0-.133.132v.608c0 .073.06.132.132.132h.728v.727c0 .074.06.133.132.133h.608a.132.132 0 0 0 .132-.133V7.21h.727a.132.132 0 0 0 .133-.132V6.47a.132.132 0 0 0-.133-.132h-.727v-.727a.132.132 0 0 0-.132-.132h-.608Zm-.86 4.142a.132.132 0 0 0-.132.132v.241c0 .074.06.133.132.133h2.328a.132.132 0 0 0 .132-.133v-.24a.132.132 0 0 0-.133-.133h-2.326Z"
      fill="#000"
    />
  </svg>
);

const Memo = memo(SvgSmartTv);
export default Memo;
